var _excluded = ["autoHideDuration", "children", "color", "horizontal", "open", "onClose", "vertical"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '../Alert';
function FlashMessage(_ref) {
  var autoHideDuration = _ref.autoHideDuration,
    children = _ref.children,
    color = _ref.color,
    horizontal = _ref.horizontal,
    open = _ref.open,
    onClose = _ref.onClose,
    vertical = _ref.vertical,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var handleClose = function handleClose() {
    onClose();
  };
  return /*#__PURE__*/React.createElement(Snackbar, _extends({
    anchorOrigin: {
      vertical: vertical,
      horizontal: horizontal
    },
    autoHideDuration: autoHideDuration,
    open: open,
    onClose: handleClose,
    ClickAwayListenerProps: {
      onClickAway: function onClickAway() {
        return null;
      }
    }
  }, rest), /*#__PURE__*/React.createElement(Alert, {
    color: color,
    onClose: handleClose,
    elevation: 7
  }, children));
}
FlashMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The number of milliseconds to wait before automatically calling the `onClose` function.
   */
  autoHideDuration: PropTypes.number,
  /**
   * The main color for the component.
   */
  color: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  /**
   * React component, HTML node, string etc..
   */
  children: PropTypes.node.isRequired,
  /**
   * Horizontal position of component
   */
  horizontal: PropTypes.oneOf(['left', 'center', 'right']),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: PropTypes.func.isRequired,
  /**
   * Vertical position of component
   */
  vertical: PropTypes.oneOf(['bottom', 'top'])
} : {};
FlashMessage.defaultProps = {
  autoHideDuration: 3500,
  color: 'success',
  open: false,
  horizontal: 'center',
  vertical: 'top'
};
export default FlashMessage;